export default __webpack_public_path__ + "static/media/jungle@304.88049a75.jpg";